module.exports = __webpack_public_path__ + "static/media/zumkha-result2.52ed1cb5.png";